"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const chalk_1 = __importDefault(require("chalk"));
const requiredEnv = {
    '@cflin/api': ['CLOUDINARY_API_SECRET'],
    '@cflin/app': [],
};
/*
  WARNING: Destructuring, const { env } = process, won't work in React.
  Looks like the env getter has been hijacked.
*/
const appName = process.env.APP_NAME || process.env.npm_package_name || process.env.REACT_APP_NAME;
if (!appName) {
    throw new Error(`App name is undefined. If this is a React app, add ${chalk_1.default.red('REACT_APP_NAME=$npm_package_name')} to your ${chalk_1.default.yellow.italic('.env.local')}.`);
}
const undefinedEnv = (_a = requiredEnv[appName]) === null || _a === void 0 ? void 0 : _a.filter(e => !(e in process.env));
if ((undefinedEnv === null || undefinedEnv === void 0 ? void 0 : undefinedEnv.length) > 0) {
    throw new Error(`Require environment variables: ${chalk_1.default.red(undefinedEnv.join(', '))}.`);
}
const env = process.env;
exports.default = env;
//# sourceMappingURL=env.js.map